import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/contactlist.css";
import "../../assets/styles/local/CompanyList.css";
import "../../assets/styles/local/AddCompany.css";
import { Image, Row, Col } from "react-bootstrap";
import Header from "../../layouts/Header";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import orderPickingFilter from "../../assets/icons/orderPickingFilter.svg";
import Conthover from "../..//assets/icons/Contacthover.svg";
import AddIcon from "../..//assets/icons/addicon.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import docicons from "../../assets/icons/Group 2949.svg";
import Taskicon from "../../assets/icons/Group 2951.svg";
import Image5 from "../..//assets/icons/Group 1277.svg";
import Loader from "../../components/Dailogs/Loader";
import moment from "moment";
import Xicon from "../../assets/icons/Xicon.svg";
import searchicon from "../../assets/icons/search.svg";
import box from "../../assets/images/box(1).png";
import box2 from "../../assets/images/box(4).png";
import NoData from "../../utils/helpers/NoData";

import {
  FetchClientsByCompany,
  AddComments,
  invoiceSendEmailCount,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/Pagination/Pagination";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import { motion, AnimatePresence } from "motion/react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const CompanyList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const ViewBy_Popup_Ref = useRef(null);
  const filter_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const isViewer = process.env.REACT_APP_IS_VIEWER;
  console.log("ASC56 Role ENV", isViewer);

  const fetchClientsByCompanyRes = useSelector(
    (state) => state.user.fetchClientsByCompanyRes
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("List-Company").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // variables state management start
  const [hovereff, setHovereff] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [companyListData, setCompanyListData] = useState([]);
  const [kebabPopupShow, setKebabPopupShow] = useState(false);
  const [addTaskModalShow, setAddTaskModalShow] = useState(false);
  console.log("ASC56", addTaskModalShow);
  const [selectedClientID, setSelectedClientID] = useState("");

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  useEffect(() => {
    if (fetchClientsByCompanyRes.status === true) {
      setCurrentPage(0);
      setCompanyListData(fetchClientsByCompanyRes.data);
      setShowLoader(false);
      setTotalPages(Math.ceil(fetchClientsByCompanyRes.data.length / perPage));
    }
  }, [fetchClientsByCompanyRes, perPage]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ViewBy_Popup_Ref.current &&
      !ViewBy_Popup_Ref.current.contains(event.target)
    ) {
      setCompanyShow(false);
      setArrowOptionsRotate(false);
    }

    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setFiltersPopupShow(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Company");

  useEffect(() => {
    setViewByTxtShow(t("Company"));
  }, [FetchTranslationList]);

  // if we want radio check uncheck then make it only one state //
  const [allFilter, setAllFilter] = useState(true);
  const [clients, setClients] = useState(false);
  const [other, setOthers] = useState(false);
  const [filtersPopupShow, setFiltersPopupShow] = useState(false);

  // asc filter status variables....
  const [allStatus, setAllStatus] = useState("");
  const [sentStatus, setSentStatus] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const [querystring, setQuerystring] = useState("");

  useEffect(() => {
    dispatch(FetchClientsByCompany(querystring, filterValue));
  }, [querystring, filterValue]);

  // ASC for Add task modal start.
  const TaskId = window.localStorage.getItem("taskid");
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );
  const [taskid, setTaskid] = useState("");
  const [contactname3, setContactname3] = useState(false);
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [taggedUser, setTaggedUser] = useState([]);
  const [minComments, setMinComments] = useState([]);
  const [val, setVal] = useState("");
  const [popups, setPopups] = useState(false);
  const [show, setShow] = useState([]);
  const initialRender5 = React.useRef(true);
  const [addTaskModal, setAddTaskModal] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);
  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);

  const [finalContact, setFinalContact] = useState("");
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [message, setMessage] = useState("");
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    // setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  useEffect(() => {
    if (TaskId) {
      // setReRenderAPI(true);
      // setShowModal(true);
      setTaskid(TaskId);
      // setModalFunctionNoty("Notification");
      // setModalFunction("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const handleAddComments = () => {
    dispatch(AddComments(userId, taskid, message, "task", imgUrl, taggedUser));
    setTimeout(() => {
      fetchComments(taskid);
    }, 1000);
    setTaggedUser([]);
    setMessage("");
    setImgUrl("");
  };
  // ASC for Add task modal end.

  // ASC BOOT DROPDOWN START.
  const [selectedLabel, setSelectedLabel] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [searchBoot, setSearchBoot] = useState("");
  const [optionsShow, setOptionsShow] = useState(false);

  const selectOptions = [
    { label: "Ankit Singh", value: "asc1" },
    { label: "Ankit Singh Chandel", value: "asc2" },
    { label: "Ankit Singh Software", value: "asc3" },
    { label: "Ankit Singh Software", value: "asc4" },
    { label: "Ankit Singh Software", value: "asc5" },
    { label: "Ankit Singh Software", value: "asc6" },
    { label: "Ankit Singh Software", value: "asc7" },
    { label: "Ankit Singh Software", value: "asc8" },
  ];
  // ASC BOOT DROPDOWN END.

  return (
    <>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4 pt-2">
            <div
              className="fw-bold Contact-heading"
              onClick={() => {
                history.push("/company-list");
              }}
            >
              {/* Company */}
              {t("Company")}
            </div>
          </div>
        }
      />

      {addTaskModalShow && (
        <AddTaskModal
          val={val}
          setVal={setVal}
          showModal={addTaskModalShow}
          setTaskid={setTaskid}
          popups={popups}
          setPopups={setPopups}
          statusList={statusList}
          showNewTaskSystem={showNewTaskSystem}
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          setShowModal={(show, reload) => {
            setAddTaskModalShow(false);
            if (reload) {
              window.localStorage.setItem("Task", "Task");
              window.localStorage.removeItem("clientaddname");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          }}
          defaultContactId={finalContact}
          setComments={setComments}
          modalFunction={"add"}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          maxComments={maxComments}
          setMaxComments={setMaxComments}
          show={show}
          setShow={setShow}
          length={length}
          setLength={setLength}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          from={moment().toDate()}
          searchText={""}
          taggedUser={taggedUser}
          setTaggedUser={setTaggedUser}
        />
      )}

      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent">
          <div className="outer">
            {/* ASC BOOT DROPDOWN START */}
            <div className="p-3 position-relative d-none" id="ascBootDrop">
              <div
                className="ascInputBootDiv px-3 d-flex"
                onClick={() => {
                  setOptionsShow(!optionsShow);
                  setArrowOptionsRotate(!arrowOptionsRotate);
                }}
              >
                <p className="mb-0 selectedInput">
                  {selectedLabel || "Select..."}
                </p>

                {selectedLabel ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSelectedLabel("");
                      setSelectedValue("");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={
                      arrowOptionsRotate ? "upArrow mt-1" : "downArrow mt-1"
                    }
                    alt=""
                    onClick={() => {
                      // setOptionsShow(!optionsShow);
                      // setArrowOptionsRotate(!arrowOptionsRotate);
                    }}
                  />
                )}
              </div>

              <AnimatePresence>
                {optionsShow && (
                  <motion.div
                    initial={{ translateY: -50, opacity: 0 }}
                    animate={{
                      translateY: 0,
                      opacity: 1,
                      transition: {
                        duration: 0.3,
                      },
                    }}
                    exit={{
                      translateY: -50,
                      opacity: 0,
                      transition: {
                        duration: 0.3,
                      },
                    }}
                    className="ascBootOptionDrop px-1"
                  >
                    <div className="ascInputBoot px-2 mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        type="text"
                        className="ps-3 bootSearch w-100 border-0"
                        placeholder="Search..."
                        value={searchBoot}
                        onChange={(e) => {
                          setSearchBoot(e.target.value);
                        }}
                      />
                    </div>
                    <div className="ascBootOptionList py-2" id="ascSelectBox">
                      {selectOptions
                        .filter((x) =>
                          // x.label
                          //   ?.toLowerCase()
                          //   .includes(searchBoot.toLowerCase()) ||
                          // x.value
                          //   ?.toLowerCase()
                          //   .includes(searchBoot.toLowerCase())

                          `${x.label} ${x.value}`
                            .toLocaleLowerCase()
                            .includes(searchBoot.toLowerCase()),
                        )
                        .map((item, index) => {
                          return (
                            <p
                              key={index}
                              className={
                                selectedValue === item.value
                                  ? "selectedItem pointer ps-3 mb-2"
                                  : "ascBootList pointer ps-3 mb-2"
                              }
                              onClick={() => {
                                setSelectedLabel(item.label);
                                setSelectedValue(item.value);
                                setSearchBoot("");
                                setOptionsShow(false);
                              }}
                            >
                              {item.label}
                            </p>
                          );
                        })}
                      {/* Display a message when no search are found */}
                      <NoData
                        selectOptions={selectOptions}
                        searchBoot={searchBoot}
                        item={searchBoot}
                      />
                      {selectOptions.length > 0 &&
                        selectOptions.filter((x) =>
                          `${x.label} ${x.value}`
                            .toLocaleLowerCase()
                            .includes(searchBoot.toLowerCase()),
                        ).length === 0 && (
                          <div className="text-center opacity-50">
                            No data found!
                            <br />
                            <img src={box2} width={45} alt="" />
                          </div>
                        )}

                      {/* Display a message when no data to display */}
                      {selectOptions.length === 0 && (
                        <div className="text-center opacity-50">
                          No data to display!
                          <br />
                          <img src={box} width={45} alt="" />
                        </div>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            {/* ASC BOOT DROPDOWN END */}

            <Row className="row-item">
              <Col xl={4} className="p-0">
                <div className="d-flex align-items-baseline">
                  <p className="mt-2 Contact-sub-heading ps-4 ps-lg-2">
                    {/* View by */}
                    {t("View by")}
                  </p>

                  <div
                    ref={ViewBy_Popup_Ref}
                    className="asc_Search_Box w-50 ms-2 d-flex pointer"
                    style={{
                      border: "0.5px solid #e0dada",
                      borderRadius: "8px",
                      background: "white",
                      boxShadow: "unset",
                    }}
                  >
                    <p
                      className="asc_Client_Input_For_Long ps-3"
                      onClick={() => {
                        setCompanyShow(!companyShow);
                        setArrowOptionsRotate(!arrowOptionsRotate);
                      }}
                    >
                      {/* {projectName ? projectName : "Select a Project"} */}
                      <p className="mb-0 selectedTxT">{viewByTxtShow}</p>
                    </p>

                    <img
                      src={DownArrowOption}
                      className={
                        arrowOptionsRotate ? "upArrow mt-1" : "downArrow mt-1"
                      }
                      alt=""
                      onClick={() => {
                        setCompanyShow(!companyShow);
                        setArrowOptionsRotate(!arrowOptionsRotate);
                      }}
                    />

                    {companyShow && (
                      <div
                        className="asc_Custom_Select_Outer pt-1"
                        style={{
                          top: "53px",
                          border: "0.5px solid #e0dada",
                          borderRadius: "8px",
                          background: "white",
                        }}
                      >
                        <div className="">
                          <p
                            className={
                              viewByTxtShow === "Contact"
                                ? "asc_Selected_Item ps-3 py-1 m-2 d-flex justify-content-between"
                                : "ps-3 py-1 m-2 hoverItem"
                            }
                            style={{ boxShadow: "unset" }}
                            onClick={() => {
                              history.push("/contact-list");
                              // setViewByTxtShow("Contact");
                              setViewByTxtShow(
                                t("Contact"),
                              );
                              setCompanyShow(false);
                              setArrowOptionsRotate(false);
                            }}
                          >
                            {/* Contact */}
                            {t("Contact")}
                            {/* {viewByTxtShow === "Contact" && (
                              <p className="mb-0 pe-2">✔</p>
                            )} */}
                            {viewByTxtShow === t("Contact") && (
                              <p className="mb-0 pe-2">✔</p>
                            )}
                          </p>
                          <p
                            className={
                              // viewByTxtShow === "Company"
                              viewByTxtShow === t("Company")
                                ? "asc_Selected_Item ps-3 py-1 m-2 d-flex justify-content-between"
                                : "ps-3 py-1 m-2 hoverItem"
                            }
                            style={{ boxShadow: "unset" }}
                            onClick={() => {
                              history.push("/company-list");
                              // setViewByTxtShow("Company");
                              setViewByTxtShow(
                                t("Company"),
                              );
                              setCompanyShow(false);
                              setArrowOptionsRotate(false);
                            }}
                          >
                            {/* Company */}
                            {t("Company")}
                            {/* {viewByTxtShow === "Company" && (
                              <p className="mb-0 pe-2">✔</p>
                            )} */}
                            {viewByTxtShow === t("Company") && (
                              <p className="mb-0 pe-2">✔</p>
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl={4} className="p-0">
                {/* <p className="mt-2 Contact-sub-heading">Filter</p> */}
                <filterSection
                  className="ps-0 ps-sm-5 pt-3 w-75 d-flex gap-2 filterTexts positionForFilterPopup"
                  ref={filter_Popup_Ref}
                >
                  <p className="ps-0 ps-sm-3">
                    {/* Filters */}
                    {t("Filters")}
                  </p>
                  <img
                    className="mb-4 pt-1 pointer"
                    src={orderPickingFilter}
                    alt=""
                    onClick={() => setFiltersPopupShow(true)}
                  />
                  <div className="d-flex gap-0 ps-2">
                    <p className="allBorder pb-4">{filterValue || "All"}</p>
                    {/* <p className="xIconInvoice px-1 pb-4">x</p> */}
                  </div>

                  {/*ASC filter popup start */}
                  <section
                    className="filterPopup h-auto"
                    style={{
                      transform: filtersPopupShow ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p
                      className="xCiecle ms-auto me-3 mt-1 pointer"
                      onClick={() => {
                        setFiltersPopupShow(false);
                      }}
                    >
                      x
                    </p>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        // value="All"
                        id="ascInvoice2"
                        checked={allFilter}
                        onClick={() => {
                          setAllFilter(!allFilter);
                          setClients(false);
                          setOthers(false);
                          setFilterValue("");
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice2"
                      >
                        <p className="mb-0 fs-6">
                          {/* All */}
                          {t("All")}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        // value="Sent"
                        id="ascInvoice3"
                        checked={clients}
                        onClick={() => {
                          setClients(!clients);
                          setFilterValue("Client");
                          setAllFilter(false);
                          setOthers(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice3"
                      >
                        <p className="mb-0 fs-6">
                          {/* Client */}
                          {t("Client")}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        value="Sent"
                        id="ascInvoice4"
                        checked={other}
                        onClick={() => {
                          setOthers(!other);
                          setFilterValue("Other");
                          setAllFilter(false);
                          setClients(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice4"
                      >
                        <p className="mb-0 fs-6">
                          {/* Other */}
                          {t("Other")}
                        </p>
                      </label>
                    </div>

                    <button
                      className="clearButton mx-3 mt-3"
                      onClick={() => {
                        setAllFilter(true);
                        setClients(false);
                        setOthers(false);

                        setSentStatus("");
                        setFilterValue("");
                      }}
                    >
                      {/* Clear */}
                      {t("Clear")}
                    </button>
                  </section>
                  {/*ASC filter popup end */}
                </filterSection>
              </Col>
              <Col xl={4} className="add-col-item pe-0">
                <div
                  onClick={() => {
                    // dispatch(RemoveDocsClientById());
                    // dispatch(EmptyProductPart());
                    // window.localStorage.removeItem("clientaddname");
                    // window.localStorage.removeItem("clientId2");
                    // window.localStorage.removeItem("_tmpCon");
                    history.push("/add-company");
                  }}
                  onMouseOver={() => setHovereff(true)}
                  onMouseOut={() => setHovereff(false)}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : "d-flex add-member-btns p-3"
                  }
                  style={{ borderRadius: "12px" }}
                >
                  {hovereff ? (
                    <Image height={17} width={21} src={AddIcon} />
                  ) : (
                    <Image height={17} width={21} src={Conthover} />
                  )}
                  <p className="add-company-text ms-3 mb-0">
                    {/* Add Company */}
                    {t("Add Company")}
                  </p>
                </div>
              </Col>
            </Row>

            <div className="ascTableWrapper mt-3 px-4">
              <table className="table">
                <thead>
                  <tr
                    className="tableHeading"
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    <th style={{ width: "30%" }}>
                      {/* Company */}
                      {t("Company")}
                    </th>
                    <th style={{ width: "13%" }}>
                      {/* Telephone */}
                      {t("Telephone")}
                    </th>
                    <th style={{ width: "25%" }}>
                      {/* E-mail */}
                      {t("E-mail")}
                    </th>
                    <th className="d-none">Type</th>
                    <th style={{ width: "15%" }}>
                      Updates
                      {/* {FetchTranslationList[39]?.translation} */}
                    </th>
                    <th style={{ width: "25%" }}>
                      {/* Account Manager */}
                      {t("Account Manager")}
                    </th>
                    <th className="">
                      {/* Last Activity */}
                      {t("Last Activity")}
                    </th>
                    <th></th>
                  </tr>
                </thead>

                <tbody
                  className="tabLine"
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {companyListData
                    .slice(currentPage * perPage, (currentPage + 1) * perPage)
                    .map((item, index) => {
                      return (
                        <tr
                          className="asc_Table_Hover"
                          // title={item.clientname.length > 10 && item.clientname}
                        >
                          <td
                            title={
                              item.clientname.length > 10 && item.clientname
                            }
                            className="pointer"
                            style={{
                              // for 3 dots 👇
                              // whiteSpace: "pre-wrap",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "10px",
                            }}
                            onClick={() => {
                              history.push(`/add-company/${item?.clientid}`);
                              window.localStorage.removeItem("taskid");
                            }}
                          >
                            {item.clientname}
                          </td>
                          {/* <td>{item.mobileNo || item.officePhoneNo}</td> */}
                          <td>
                            {item.mobileNo || item.officePhoneNo
                              ? `+ ${item.mobileNo || item.officePhoneNo}`
                              : ""}
                          </td>
                          <td>{item.email}</td>
                          <td className="d-none">{item.mobileNoType}</td>
                          <td>{moment(item.updatedat).format("DD.MM.YYYY")}</td>
                          <td>{item.accountmanagerName}</td>

                          <td>{item.lastActivity.split("by")[0]}</td>

                          {/* <td
                           dangerouslySetInnerHTML={{ __html: item.lastActivity.replace(' by ', '<br>by ') }}>
                          </td> */}

                          {/* <td
                            dangerouslySetInnerHTML={{
                              __html: item.lastActivity.replace(
                                " by ",
                                "<br> by "
                              ),
                            }}
                          ></td> */}

                          <td className="d-none">
                            {moment(item.duedate).format("DD.MM.YYYY")}
                          </td>
                          <td className="position-relative">
                            <img
                              className="pointer"
                              src={Kebab}
                              alt=""
                              onClick={() => {
                                setKebabPopupShow(true);
                                setSelectedClientID(item.clientid);
                                localStorage.setItem(
                                  "companyClientNameFrom3Dot",
                                  item.clientname,
                                );
                                localStorage.setItem(
                                  "comapanyClientIDFrom3Dot",
                                  item.clientid,
                                );
                              }}
                            />
                            {kebabPopupShow &&
                              item.clientid === selectedClientID && (
                                <div className="companyKebabPopup p-3">
                                  <div className="pointer text-end pe-2">
                                    <img
                                      src={Kebab}
                                      alt=""
                                      style={{ rotate: "90deg" }}
                                      onClick={() => {
                                        setKebabPopupShow(false);
                                      }}
                                    />
                                  </div>
                                  <div className="kebabTxt pointer">
                                    <div
                                      className="d-flex gap-2"
                                      // onClick={() => {
                                      //   history.push(
                                      //     "/add-contact",
                                      //     item.clientname
                                      //   );
                                      // }}
                                      onClick={() => {
                                        history.push({
                                          pathname: "/add-contact",
                                          state: {
                                            from: "CompanyList_Screen",
                                            companyName: item.clientname,
                                          },
                                        });
                                      }}
                                    >
                                      <img src={Image5} alt="" />
                                      <p>
                                        {/* Add Contact */}
                                        {t("Add Contact")}
                                      </p>
                                    </div>
                                    <div
                                      className="d-flex gap-2"
                                      onClick={() => {
                                        localStorage.setItem(
                                          "addDocCompanyList",
                                          true,
                                        );
                                        history.push(
                                          `/add-company/${item?.clientid}`,
                                        );
                                      }}
                                    >
                                      <img src={docicons} alt="" />
                                      <p>
                                        {/* Add Doc */}
                                        {t("Add Doc")}
                                      </p>
                                    </div>
                                    <div
                                      className="d-flex gap-2"
                                      onClick={() => {
                                        setAddTaskModalShow(true);
                                        localStorage.setItem(
                                          "companyClientNameFrom3Dot",
                                          item.clientname,
                                        );
                                        localStorage.setItem(
                                          "comapanyClientIDFrom3Dot",
                                          item.clientid,
                                        );
                                      }}
                                    >
                                      <img src={Taskicon} alt="" />
                                      <p>
                                        {/* Add Task */}
                                        {t("Add Task")}
                                      </p>
                                    </div>
                                    <div
                                      className="d-flex gap-2"
                                      onClick={() => {
                                        history.push({
                                          pathname: "/addProject",
                                          state: "/project",
                                          ascState: {
                                            from: "CompanyList_Screen",
                                            clientName: item.clientname,
                                            clientId: item.clientid,
                                            clientAddress:
                                              item.streetNameAndNumber,
                                          },
                                        });
                                      }}
                                    >
                                      <img src={docicons} alt="" />
                                      <p>
                                        {/* Add Project */}
                                        {t("Add Project")}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      );
                    })}
                  {companyListData.length === 0 && (
                    <span className="noDataDisplay">
                      No data to display!
                      {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                    </span>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />

            {/* add button for mobile view start */}
            <Row className="p-custom pt-5">
              <Col>
                <div
                  onClick={() => {
                    // dispatch(RemoveDocsClientById());
                    // dispatch(EmptyProductPart());
                    // window.localStorage.removeItem("clientaddname");
                    // window.localStorage.removeItem("clientId2");
                    // window.localStorage.removeItem("_tmpCon");
                    history.push("/add-company");
                  }}
                  onMouseOver={() => setHovereff(true)}
                  onMouseOut={() => setHovereff(false)}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : "d-flex add-member-btns d-none addButtonMobile"
                  }
                  style={{ borderRadius: "12px" }}
                >
                  {hovereff ? (
                    <Image height={17} width={21} src={AddIcon} />
                  ) : (
                    <Image height={17} width={21} src={Conthover} />
                  )}
                  <p className="add-company-text ms-3 mb-0">
                    {/* Add Company */}
                    {t("Add Company")}
                  </p>
                </div>
              </Col>
            </Row>
            {/* add button for mobile view end */}
          </div>
        </div>
      )}
    </>
  );
};

export default CompanyList;
